export default "__VITE_ASSET__0f0abc20__"